<div class="user-info-dialog">
    <h2 mat-dialog-title>User Information</h2>

    @if (user()) {
        <mat-dialog-content>
            <!-- User Basic Information -->
            <div class="user-details mat-elevation-z2">
                <h3>Personal Details</h3>
                <div class="details-grid">
                    <div class="detail-item">
                        <span class="detail-label">ID:</span>
                        <span class="detail-value">{{ user()!.id }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">First Name:</span>
                        <span class="detail-value">{{ user()!.firstName }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Last Name:</span>
                        <span class="detail-value">{{ user()!.lastName }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Username:</span>
                        <span class="detail-value">{{ user()!.userName }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Email:</span>
                        <span class="detail-value">{{ user()!.email }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Registration Date:</span>
                        <span class="detail-value">{{ user()!.registrationDate | date: "medium" }}</span>
                    </div>
                </div>
            </div>

            <!-- Broker Accounts Section -->
            <div class="broker-accounts-section">
                <h3>Broker Accounts</h3>

                @if (user()!.brokerAccounts.length === 0) {
                    <div class="no-data">No broker accounts found</div>
                }

                @for (account of user()?.brokerAccounts; track account.id) {
                    <div class="broker-account-card mat-elevation-z2">
                        <div class="account-header">
                            <div class="account-info">
                                <h4>{{ account.displayName }}</h4>
                                <div class="account-meta">
                                    <span class="provider-type">{{ account.providerType | providerType }}</span>
                                    <span class="account-type">{{ account.accountType | accountType }}</span>
                                </div>
                            </div>
                            @if (false) {
                                <button mat-icon-button [matMenuTriggerFor]="accountMenu" aria-label="Account actions">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                            }
                            <mat-menu #accountMenu="matMenu">
                                <button mat-menu-item>
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit Account</span>
                                </button>
                                <button mat-menu-item>
                                    <mat-icon>{{ account.isActive ? "block" : "check_circle" }}</mat-icon>
                                    <span>{{ account.isActive ? "Deactivate" : "Activate" }}</span>
                                </button>
                                <button mat-menu-item>
                                    <mat-icon color="warn">delete</mat-icon>
                                    <span>Delete Account</span>
                                </button>
                            </mat-menu>
                        </div>

                        <div class="account-details">
                            <div class="detail-item">
                                <span class="detail-label">Account ID:</span>
                                <span class="detail-value">{{ account.id }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">External ID:</span>
                                <span class="detail-value">{{ account.externalId }}</span>
                            </div>
                            <div class="detail-item detail-item--wide">
                                <span class="detail-label">Account lock:</span>
                                <app-trading-lock
                                    [brokerAccount]="account"
                                    (stateChange)="setAccountLockState(account.id, $event)"
                                />
                            </div>
                        </div>

                        <!-- Bots Table -->
                        @if (account.bots && account.bots.length > 0) {
                            <div class="bots-section">
                                <h5>Trading Bots</h5>
                                <div class="table-scroll-container">
                                    <table mat-table [dataSource]="account.bots" class="bots-table">
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef>Bot Name</th>
                                            <td mat-cell *matCellDef="let bot">{{ bot.name }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="id">
                                            <th mat-header-cell *matHeaderCellDef>Bot ID</th>
                                            <td mat-cell *matCellDef="let bot">{{ bot.id }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef>Status</th>
                                            <td mat-cell *matCellDef="let bot">
                                                <mat-chip [class]="'status-' + bot.status">
                                                    {{ bot.status | botStatusType }}
                                                </mat-chip>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="tradingLock">
                                            <th mat-header-cell *matHeaderCellDef>Bot lock</th>
                                            <td mat-cell *matCellDef="let bot">
                                                <app-trading-lock
                                                    [brokerAccount]="account"
                                                    [bot]="bot"
                                                    [accountLockKind]="accountLockKinds().get(account.id)"
                                                />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="actions">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                                            <td mat-cell *matCellDef="let bot">
                                                <button
                                                    mat-icon-button
                                                    [matMenuTriggerFor]="botMenu"
                                                    aria-label="Bot actions"
                                                >
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                                <mat-menu #botMenu="matMenu">
                                                    <button mat-menu-item (click)="reloadBotData(bot.id)">
                                                        <mat-icon>refresh</mat-icon>
                                                        <span>Reload bot data</span>
                                                    </button>
                                                    <button mat-menu-item (click)="runBot(bot.id)">
                                                        <mat-icon>play_arrow</mat-icon>
                                                        <span>Run bot</span>
                                                    </button>
                                                </mat-menu>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="botColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: botColumns"></tr>
                                    </table>
                                </div>
                            </div>
                        }

                        @if (!account.bots || account.bots.length === 0) {
                            <div class="no-bots">
                                <mat-icon>info</mat-icon>
                                <span>No bots assigned to this account</span>
                            </div>
                        }
                    </div>
                }
            </div>
        </mat-dialog-content>
    }

    @if (!user()) {
        <mat-dialog-content class="loading-container">
            <p>Loading user information...</p>
        </mat-dialog-content>
    }

    <mat-dialog-actions align="end">
        <button mat-button (click)="dialogRef.close()">Close</button>
    </mat-dialog-actions>
</div>
